/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import React from "react";
import { useSelector } from "react-redux";
import { setSelectedUserFileMgmt } from "../../../../store/api/admin/reducers";
import { setBasicDialogOpenFor, setErrorMsg } from "../../../../store/helpers/helperReducers";
import { isLoadingStatusSelector } from "../../../../store/helpers/helperSelectors";
import { initialState } from "../../../../store/api/admin/initialState";
import { isError } from "../../../../utils/validations";
import { useExternalFormDataUserFileMgmt } from "./hooks";
import { Sheet } from "../../../ui/sheet";
import { Button } from "../../../ui/button";
import { InputField } from "../../../Shared/Radix/Inputs/InputField";

const AddEditExternalUserFileMgmt: React.FC = () => {
  const { dispatch, formData, setFormData, errMsg, setErrMsg, submitHandler, onBlurHandler, isAddNew } = useExternalFormDataUserFileMgmt();
  const isLoadingStatus = useSelector(isLoadingStatusSelector);

 
  const handleFieldChange = (name: string, value: string) => {
    setFormData({ ...formData, [name]: value });
    setErrMsg({ ...errMsg, [name]: "" });
  };

  const handleClose = () => {
    dispatch(setBasicDialogOpenFor(undefined));
    dispatch(setSelectedUserFileMgmt(initialState.selectedUserFileMgmt));
    dispatch(setErrorMsg({}));
    setErrMsg({});
  };

  const enableSave = !!formData?.username && !!formData?.key && !isError(errMsg);

  const footer = (
    <>
      <Button variant="outline" onClick={handleClose} disabled={isLoadingStatus["userFileMgmt"]}>
        Cancel
      </Button>
      <Button onClick={submitHandler} disabled={isLoadingStatus["userFileMgmt"] || !enableSave}>
        Save
      </Button>
    </>
  );

  return (
    <Sheet open={true} onClose={handleClose} title={isAddNew ? "Add New External User" : "Update External User"} footer={footer} width="520px">
      <form autoComplete="off">
        <div className="space-y-4 pt-2">
          {/* User Name */}
          <InputField
            name="username"
            label="User Name"
            required
            value={formData?.username || ""}
            onChange={handleFieldChange}
            onBlur={onBlurHandler}
            disabled={!isAddNew}
            maxLength={255}
            placeholder="Enter user name"
            tooltipText="Maximum length: 255 characters"
            autoFocus
            controlSize="md"
          />

          {/* SSH-Key */}
          <InputField
            name="key"
            label="SSH-Key"
            required
            value={formData?.key || ""}
            onChange={handleFieldChange}
            onBlur={onBlurHandler}
            placeholder="ssh-ed25519 AAAA... user@host"
            controlSize="lg"
          />
        </div>
      </form>
    </Sheet>
  );
};
export default AddEditExternalUserFileMgmt;
